<!--
  The card in place. Untouched by the expand, so a carousel around it keeps its measurements.
-->
<div
  #card
  class="expandable-card"
  [class.is-expandable]="expandable"
  [style.borderRadius.px]="resolvedRadius"
  (click)="open($event)"
  [attr.role]="expandable ? 'button' : null"
  [attr.tabindex]="expandable ? 0 : null"
  (keydown.enter)="open($event)"
  (keydown.space)="open($event)"
>
  <ng-container *ngTemplateOutlet="header"></ng-container>
  <!--
    Hidden outright while the card is open, since the panel covers it, then faded back in once the
    panel has shrunk away and this is what the eye lands on.
  -->
  <div class="expandable-card-card-footer" [class.is-hidden]="cardFooterHidden" [class.is-revealing]="cardFooterRevealing">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </div>
</div>

<!--
  The fullscreen copy. Moved to body on open, so a transformed ancestor cannot trap it.
-->
<div #overlay class="expandable-card-overlay" *ngIf="isExpanded">
  <!-- Dims what is behind as the card lifts, in the club's own background colour. -->
  <div #scrim class="expandable-card-scrim" (click)="close($event)"></div>

  <!-- Outside the panel, which is scaled horizontally and would stretch the button with it. -->
  <button
    #closeBtn
    type="button"
    class="expandable-card-close border-0 d-flex align-items-center justify-content-center"
    (click)="close($event)"
    aria-label="Close"
  >
    <span class="material-icons text-white" aria-hidden="true">arrow_back_ios_new</span>
  </button>

  <div #panel class="expandable-card-panel" [class.is-animating]="isAnimating" role="dialog" aria-modal="true">
    <!-- Counter-scaled against the panel, so the contents are never stretched mid-flight. -->
    <div #inner class="expandable-card-panel-inner" [class.is-text-only]="!showImage">
      <ng-container *ngTemplateOutlet="header"></ng-container>

      <!-- The footer strip, now grown into the page. -->
      <div #article class="expandable-card-article" [class.is-settled]="showArticle">
        <!--
          The strip's own text. It belongs to the collapsed card, so it collapses away as the page
          opens rather than sitting above the expanded content. Driven by a class rather than a
          tween, so a later render cannot put it back.
        -->
        <div class="expandable-card-footer-slot" [class.is-hidden]="hideFooterText" *ngIf="!footerTextGone">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </div>

        <div class="expandable-card-body" *ngIf="showArticle">
          <ng-container *ngTemplateOutlet="expandedContent"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #header>
  <div class="expandable-card-header" *ngIf="showImage">
    <ng-container *ngIf="headerContent; else defaultHeader">
      <ng-container *ngTemplateOutlet="headerContent"></ng-container>
    </ng-container>

    <ng-template #defaultHeader>
      <img *ngIf="image" class="expandable-card-image" [src]="image" [alt]="imageAlt" />
    </ng-template>
  </div>
</ng-template>

<!-- The footer strip. This is the sliver that grows into the full page. -->
<ng-template #footer>
  <div class="expandable-card-footer" [class.is-text-only]="!showImage" *ngIf="footerTitle || (caption && showDescription)">
    <div class="expandable-card-footer-text" [style.--expandable-card-caption-lines]="captionLines">
      <h6 class="expandable-card-footer-title" *ngIf="footerTitle">{{ footerTitle }}</h6>
      <!-- innerHTML, so a caller can pass markup through pipes rather than only plain text. -->
      <p class="expandable-card-footer-caption" *ngIf="caption && showDescription" [innerHTML]="caption"></p>
    </div>
  </div>
</ng-template>
